import { Modulos } from "@/typings/store/plugins/easyFirestore/iniciar/modulos";

/**
 * Módulos que se abren al hacer login (catálogos pequeños, bajo uso de memoria).
 * mapeoGastos y matrizPagos se abren solo al entrar a su ruta (modulosPorRuta).
 */
export const modulosAlLogin: Modulos = [
  { nombre: "usuarios", permisos: [], parametros: [], where: [] },
  { nombre: "regiones", permisos: [], parametros: [], where: [] },
  { nombre: "ciudades", permisos: [], parametros: [], where: [] },
  { nombre: "contactos", permisos: [], parametros: [], where: [] },
  { nombre: "bancos", permisos: [], parametros: [], where: [] },
  { nombre: "centrosCostos", permisos: [], parametros: [], where: [] },
  { nombre: "codCuentas", permisos: [], parametros: [], where: [] },
  { nombre: "tipoEgresos", permisos: [], parametros: [], where: [] },
  { nombre: "proveedores", permisos: [], parametros: [], where: [] },
  { nombre: "tipoDocumentos", permisos: [], parametros: [], where: [] },
  { nombre: "tipoCargos", permisos: [], parametros: [], where: [] },
];

/**
 * Módulos "pesados" que se abren solo al entrar a la ruta indicada.
 * Al salir de la ruta se cierran para liberar memoria.
 */
export const modulosPorRuta: Record<string, string[]> = {
  ordenes: ["ordenes", "mapeoGastos"],
  prenominas: ["prenominas", "mapeoGastos"],
  // Facturas.vue lee la colección directo (filtrada y ordenada); no abre canal para no leerla dos veces.
  facturas: [],
  registrosEgresos: ["registrosEgresos", "mapeoGastos", "prenominas"],
  // El formulario y las condiciones del contrato usan clientes, locales, condiciones y divisiones.
  contratos: [
    "contratos",
    "clientes",
    "locales",
    "condicionesComerciales",
    "condicionesDivisiones",
  ],
  clientes: ["clientes"],
  locales: ["locales"],
  ingresos: ["ingresos"],
  notasCredito: ["notasCredito"],
  condicionesDivisiones: ["condicionesDivisiones"],
  condicionesComerciales: ["condicionesComerciales"],
  cajaChicas: ["cajaChicas"],
  cajaChicasLinares: ["cajaChicasLinares"],
  cajaChicasTalca: ["cajaChicasTalca"],
  cajaChicasSantiagoVV: ["cajaChicasSantiagoVV"],
  cajaChicasSantiagoOF: ["cajaChicasSantiagoOF"],
  cajaChicasTalcaGerencial: ["cajaChicasTalcaGerencial"],
  mapeoGastos: ["mapeoGastos"],
  matrizPagos: ["matrizPagos"],
  visualizacionPagos: ["prenominas", "ordenes"],
};

/** Lista de todos los nombres de módulos (para cerrar todo al hacer logout). */
export const todosLosNombresModulos: string[] = [
  ...modulosAlLogin.map((m) => m.nombre),
  ...Object.values(modulosPorRuta).flat(),
].filter((nombre, index, arr) => arr.indexOf(nombre) === index);

/** Compatibilidad: export por defecto para abrirCanalesBD (usa solo los de login). */
const modulos = modulosAlLogin;
export default modulos;
